import { styled } from '@mui/material/styles'
import { ExpandMoreIcon } from '@dhl-ui/icons'

type Props = {
  isOpen: boolean
}

export const ExpandMore: React.FC<Props> = styled(ExpandMoreIcon, {
  shouldForwardProp: (prop) => prop !== 'isOpen',
})<Props>(({ theme, isOpen }) => ({
  transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}))
